import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3.01v18H21V3zm-2 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"
}), 'InboxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InboxSharp.js
// module id = 4238
// module chunks = 2